/**
 * @ngdoc Controller
 * @name ProfileController
 */
(function () {
    'use strict';

    angular.module('vrm.core').controller('AdminController', AdminController);

    /**
     * @constructor
     * @ngInject
     */
    function AdminController($log) {
        $log.info('AdminController');
    }

})();
